// extracted by mini-css-extract-plugin
module.exports = {"container":"_93444fe79c--container--WqNsb","text":"_93444fe79c--text--vnF_K"};